exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blockSteps{pointer-events:none}.nav_download_btn{float:right;margin-top:-45px;margin-right:15px}@media only screen and (min-width: 768px) and (max-width: 1440px){.nav_download_btn{margin-top:-37px}}@media only screen and (max-width: 767px){.nav_download_btn{margin:10px;float:none;text-align:center}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create/universe_lite/Analyze/analysis/navigation/nav.style.scss
// module id = 869
// module chunks = 0